import { useCallback, useEffect, useState } from "react";
import { useChatActions, useChatData, useChatMessages, useChatTokens } from "../store/chat";
import { ChatBox } from "./components/ChatBox";
import { ChatLogin } from "./components/ChatLogin";

export const ChatBubble = () => {
  const chatData = useChatData();
  const chatActions = useChatActions();
  const chatMessages = useChatMessages();
  const tokens = useChatTokens();
  const [showLogin, setShowLogin] = useState(false);
  const [username, setUsername] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  // As soon as the component is mounted, chat connects to server
  useEffect(() => {
    chatActions.connect();
  }, []);

  const handleUsernameSubmit = useCallback(() => {
    if (!username || (!tokens.facebook && !tokens.google)) {
      return;
    }
  }, [username, tokens]);

  const handleChatMessageClick = useCallback(() => {
    if (chatData.loggedIn) {
      if (!message) {
        return;
      }
      chatActions.sendChatMessage(message);
      setMessage("");
    } else {
      setShowLogin(true);
    }
  }, [message, chatActions, chatData]);

  const handleLoginFacebookClick = useCallback(async () => {
    await chatActions.loginWithFacebook(username);
    setShowLogin(false);
    // if (username) {
    //   chatActions.connect(username);
    // }
  }, [username, chatActions]);

  const handleGoogleSuccess = useCallback(
    async (token: string) => {
      chatActions.loginWithGoogle(username, token);
      setShowLogin(false);
    },
    [chatActions, username]
  );

  const handleGoToSettings = useCallback(() => {
    setShowLogin(true);
  }, []);

  const closeChat = useCallback(() => {
    chatActions.showChat(false);
  }, [chatActions]);

  const handleLoginGoBack = useCallback(() => {
    setShowLogin(false);
  }, [setShowLogin]);

  useEffect(() => {
    if (chatData.loggedIn) {
      setShowLogin(false);
    }
  }, [chatData.loggedIn]);

  // useEffect(() => {
  //   if (tokens.facebook || tokens.google) {
  //     handleUsernameSubmit();
  //   }
  // }, [tokens, handleUsernameSubmit]);

  return (
    <div className="fixed w-full h-[calc(100%-5rem)] bottom-20 lg:bottom-[4.5rem] lg:right-3 lg:min-w-[300px] lg:max-w-sm lg:h-96 lg:rounded-xl drop-shadow-xl flex flex-row items-center bg-[#FAEFFF] border-[2px] border-gray">
      {showLogin && (
        <ChatLogin
          key="chat-login"
          goBack={handleLoginGoBack}
          username={username}
          onSubmit={handleUsernameSubmit}
          onUsernameChange={setUsername}
          onFacebookLoginClick={handleLoginFacebookClick}
          onGoogleLoginSucces={handleGoogleSuccess}
        />
      )}
      {!showLogin && chatData.connected && (
        <ChatBox
          key="chat-box"
          messages={chatMessages}
          currentMessage={message}
          userId={chatData.userId}
          loggedIn={chatData.loggedIn}
          setCurrentMessage={setMessage}
          sendMessage={handleChatMessageClick}
          goToSettings={handleGoToSettings}
          closeChat={closeChat}
        />
      )}
    </div>
  );
};

// const scrollToBottom = useCallback(() => {
//   if (!messageListRef.current) {
//     return;
//   }
//   messageListRef.current.scrollTo({
//     top: 999999,
//   });
// }, []);

// nice effect to keep bottom always visible
// useEffect(() => {
//   if (chatData.username && chatData.scrollToBottom) {
//     scrollToBottom();
//     // setTimeout(() => {
//     //   messageListRef.current?.addEventListener("scroll", () => {
//     //     chatActions.disableAutoScroll();
//     //   });
//     // }, 1000);
//   }
// }, [
//   chatActions.messages,
//   chatActions.scrollToBottom,
//   chatActions.disableAutoScroll,
//   scrollToBottom,
// ]);
